
import React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Box, Button, Field, Flex, Grid } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';
import { navigate } from 'gatsby-link';

import ModalLayout, {
  closeTimeoutMS,
  defaultModalStyles,
} from '@src/components/layout/modalLayout';
import { setUser } from '@src/services/auth';
import api from '@src/utils/api.js';

const resetPasswordModal = ({ isOpen, onClose, showClose = true }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState(false);

  const onSubmit = async (data) => {
    const dto = {
      email: data.email,
    };

    try {
      const response = await api.post('auth/remindPassword', dto);

      if (response.message == 'success') {
        setSuccessMessage(true);
      }

      // todo: I don't know what is happening here :thinking: need to investigate
      if (response?.authToken) {
        setUser({
          userToken: response?.authToken,
          role: response?.role,
        });
      }

      navigate(`/`);
    } catch (error) {
      setErrorMessage('Failed to send password reset. Try again later');
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      onRequestClose={onClose}
      closeTimeoutMS={closeTimeoutMS}
      style={defaultModalStyles}
    >
      <ModalLayout>
        <Box
          bg="white"
          sx={{
            position: 'relative',
            borderRadius: '10px',
            overflow: 'hidden',
            height: '100%',
          }}
        >
          {showClose ? (
            <Button
              variant="empty"
              sx={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                fontSize: '14px',
                color: 'text',
              }}
              onClick={onClose}
            >
              {t('close')}
            </Button>
          ) : (
            <></>
          )}
          <Grid columns={[1]} gap={0}>
            <Box px="60px" py={4}>
              <Themed.h3 sx={{ textAlign: 'center', fontSize: '28px' }}>
                {t('restorePassword')}
              </Themed.h3>
              <form
                onSubmit={handleSubmit(onSubmit)}
                sx={{ maxWidth: '350px', margin: 'auto' }}
              >
                <Box className="labels-on-inputs" sx={{ paddingBottom: 4 }}>
                  <Field
                    label={t('email')}
                    name="email"
                    {...register('email', {
                      required: true,
                    })}
                    className={errors.email ? 'field-error' : ''}
                    sx={{ width: '350px' }}
                  />

                  {errors.email && (
                    <span sx={{ color: 'error' }}>{t('fieldRequired')}</span>
                  )}
                  {errorMessage}

                  {successMessage && (
                    <div
                      sx={{
                        color: '#287a41',
                        mt: '10px',
                      }}
                    >
                      {t('emailSendSuccessfully')}
                    </div>
                  )}
                </Box>

                <Button className="w-100" type="submit">
                  {t('restorePassword')}
                </Button>

                <Flex py={3} sx={{ alignItems: 'center' }}>
                  <p>{t('doYouKnowLogin')}</p>
                  <Themed.a
                    sx={{
                      marginLeft: 'auto',
                      color: 'primary',
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      onClose();
                    }}
                  >
                    {t('logIn')}
                  </Themed.a>
                </Flex>
              </form>
            </Box>
          </Grid>
        </Box>
      </ModalLayout>
    </ReactModal>
  );
};

export default resetPasswordModal;
